export default __webpack_public_path__ + "static/media/icons8-task.66676f37.svg";